import { DefaultTheme } from '../../components/theme';

export const CSS = {
	container: 'c-Dash-Table',
	title: 'c-Dash-Table__Title',
	header: 'c-Dash-Table__Header',
	body: 'c-Dash-Table__Body',
	row: 'c-Dash-Table__row',
	cell: 'c-Dash-Table__cell',
	MDL: {
		table: 'mdl-data-table',
		cell: 'mdl-data-table__cell--non-numeric',
	},
};

const TITLE_HEIGHT = DefaultTheme.space(12);

export const Style = {
	[CSS.container]: {
		'box-shadow': DefaultTheme.shadow.box.dp2,
		margin: DefaultTheme.space(4),
	},
	[CSS.title]: {
		display: 'flex',
		'justify-content': 'space-between',
		height: TITLE_HEIGHT,
		'line-height': TITLE_HEIGHT,
		padding: `0 ${DefaultTheme.space(6)}`,
		'& h6': {
			margin: 0,
			'line-height': TITLE_HEIGHT,
		},
		'& button': {
			margin: 0,
			'line-height': TITLE_HEIGHT,
		},
		'& div': {
			width: '100%',
		},
	},
	[`${CSS.header} th`]: {
		'font-weight': DefaultTheme.font.weight.normal,
	},
	[CSS.body]: {
		width: '100%',
		border: 0,
		'background-color': 'transparent',
		'table-layout': 'fixed',
		'& td:first-of-type, & th:first-of-type': {
			width: '100px',
		},
		['& td']: {
			'border-top': 0,
		},
	},
	[CSS.cell]: {
		'max-width': '100%',
		'text-overflow': 'ellipsis',
		'white-space': 'nowrap',
		overflow: 'hidden',
	},
};
